import React, {memo, useRef, useState, useCallback} from 'react';
import {Modal, Pressable, View} from 'react-native';
import {createUseStyle} from '@redlink/assets/styles';
import {useLocale} from "@redlink/assets/locale";

const SPACE_BETWEEN_BUTTON = 10;

export const ToolTipContainer = memo(
    ({
         children,
         containerStyle,
         anchorLayout: {x = 0, y = 0, width = 0, height = 0} = {},
         isVisible = false,
         onDismiss,
         onHide,
     }) => {
        const [layout, setLayout] = useState({});
        const {styles} = useStyle();
        const elementRef = useRef(null);
        const {isRtl} = useLocale();

        const onLayout = useCallback(() => {
            elementRef.current?.measure((fx, fy, width, height, px, py) => {
                setLayout({x: px, y: py, width, height});
            });
        }, []);

        return (
            <Modal animationType="fade" transparent visible={isVisible}>
                <View
                    style={{
                        flex: 1,
                        backgroundColor: 'rgba(0,0,0,0.1)',
                    }}
                >
                    <Pressable onHoverOut={onDismiss}>
                        <View
                            ref={elementRef}
                            {...{onLayout}}
                            style={[
                                containerStyle,
                                styles.container,
                                {
                                    ...(isRtl && {right: x}),
                                    ...(!isRtl && {
                                        left: x - (layout.width - width),
                                    }),
                                    minWidth: width,
                                    top: y,
                                    paddingTop: height + SPACE_BETWEEN_BUTTON,
                                },
                            ]}
                        >
                            <View style={styles.innerContainer}>{children}</View>
                        </View>
                    </Pressable>
                </View>
            </Modal>
        );
    }
);

const useStyle = createUseStyle(({colors, size, shadow, theme}) => ({
    container: {
        position: 'absolute',
    },
    innerContainer: {
        backgroundColor: colors.white,
        padding: 10,
        borderRadius: 10,
    },
}));
